// reports_dashboard.js

(function () {
  // 既存に合わせて保持（他ファイルでも使っているならそのまま）
  let pieChart = null;               // 既存の円グラフ
  let documentDailyChart = null;     // 日別折れ線（使っていなければそのままでOK）
  // 初期化済みのダッシュボード要素。turbolinks:load と DOMContentLoaded の両方が発火しても、
  // 同じ画面(同じDOM)で initDashboard が2回走り、重い集計APIが二重に呼ばれるのを防ぐ。
  // 画面遷移や戻る操作で作り直されたDOMは別要素になるので、その場合は通常どおり初期化される。
  const _initializedRoots = new WeakSet();
  // 直近のワードクラウドデータをキャッシュして再描画に使う
  let _keywordCloudCache = { list: null, max: 0 };
  let _wordCloudRO = null; // ResizeObserver


  // ★ 初期化（ページ訪問ごとに実行）
  function initDashboard() {
    const root = document.querySelector(".report-dashboard-page");
    if (!root) return;
    if (_initializedRoots.has(root)) return;
    _initializedRoots.add(root);

    const startInput = document.getElementById("report-start-date");
    const endInput   = document.getElementById("report-end-date");
    const refreshBtn = document.getElementById("report-refresh-btn");

    // APIエンドポイント（data属性から取得）
    const urls = {
      summary:         root.dataset.summaryUrl,
      loyalty:         root.dataset.loyaltyUrl,
      categories:      root.dataset.categoriesUrl,
      prefectures:     root.dataset.prefecturesUrl,
      aiconcierges:    root.dataset.aiconciergesUrl,
      keywords:        root.dataset.keywordsUrl,
      documentsDaily:  root.dataset.documentsDailyUrl
    };

    // 初期値：今日を含む過去1週間（7日間。未入力時のみセット）
    setDefaultRange(startInput, endInput);

    // まず全ウィジェットに「読み込み中…」を即時表示（あなたの既存関数）
    if (typeof showLoadingAll === "function") {
      showLoadingAll();
    }

    // 初期表示：全ウィジェット読み込み
    reloadAll(urls, startInput, endInput);

    // 更新ボタン：画面(DOM)ごとに1回だけ処理を付与
    if (refreshBtn) {
      refreshBtn.addEventListener("click", function () {
        // クリア → ローディング → 再取得（clearAllWidgets があれば呼ぶ）
        if (typeof clearAllWidgets === "function") clearAllWidgets();
        if (typeof showLoadingAll === "function")  showLoadingAll();
        reloadAll(urls, startInput, endInput);
      });
    }
  }

  // ★ Turbo（アプリ内遷移）で初期化
  document.addEventListener("turbo:load", initDashboard);
  document.addEventListener("turbolinks:load", initDashboard);

  // ★ フルリロード（URL直打ち/更新）でも保険で初期化
  document.addEventListener("DOMContentLoaded", initDashboard);

  // ★ Turboのスナップショット保存前にクリーンアップ（戻った時の二重描画防止）
  document.addEventListener("turbo:before-cache", () => {
    try {
      if (pieChart) { pieChart.destroy(); pieChart = null; }
      if (documentDailyChart) { documentDailyChart.destroy(); documentDailyChart = null; }
    } catch (_) {}

    // キャンバスの描画をざっくりクリア（存在すれば）
    const ids = ["prefecturePieChart", "documentDailyChart", "wordCloudCanvas"];
    ids.forEach((id) => {
      const c = document.getElementById(id);
      if (!c) return;
      const ctx = c.getContext("2d");
      if (ctx) ctx.clearRect(0, 0, c.width, c.height);
    });
  });

  function setDefaultRange(startInput, endInput) {
    const today = new Date();
    const end = formatDate(today);

    const startDate = new Date(today);
    startDate.setDate(startDate.getDate() - 6); // 今日を含めて7日間
    const start = formatDate(startDate);

    if (startInput && !startInput.value) startInput.value = start;
    if (endInput && !endInput.value) endInput.value = end;
  }

  // 追加: まず全ウィジェットに「読み込み中…」を即時表示
  function showLoadingAll() {
    setTotalUsersLoading();
    setLoyaltyLoading();
    setCategoriesLoading();
    setPrefectureLoading();
    setAIConciergeLoading();
    setKeywordCloudLoading();
    setDocumentDailyLoading();
  }

  function setTotalUsersLoading() {
    const el = document.querySelector("[data-widget='total-users']");
    if (el) el.innerHTML = '<span class="report-dashboard-page__loading">読み込み中...</span>';
  }

  function setLoyaltyLoading() {
    const tbody = document.querySelector("[data-widget='loyalty-body']");
    if (tbody) {
      tbody.innerHTML = '<tr><td colspan="2" class="report-dashboard-page__loading">読み込み中...</td></tr>';
    }
  }

  function setCategoriesLoading() {
    const tbody = document.querySelector("[data-widget='category-body']");
    if (tbody) {
      tbody.innerHTML = '<tr><td colspan="2" class="report-dashboard-page__loading">読み込み中...</td></tr>';
    }
  }

  function setPrefectureLoading() {
    const msg   = document.getElementById("prefecturePieChartMessage");
    const tbody = document.querySelector("[data-widget='prefecture-body']");
    if (msg)   msg.innerHTML  = '<div class="report-dashboard-page__loading">読み込み中...</div>';
    if (tbody) tbody.innerHTML = '<tr><td colspan="3" class="report-dashboard-page__loading">読み込み中...</td></tr>';
    if (pieChart) { pieChart.destroy(); pieChart = null; }
  }

  function setAIConciergeLoading() {
    const tbody = document.querySelector("[data-widget='ai-concierge-body']");
    if (tbody) {
      tbody.innerHTML = '<tr><td colspan="2" class="report-dashboard-page__loading">読み込み中...</td></tr>';
    }
  }

  function setKeywordCloudLoading() {
    const msg    = document.getElementById("wordCloudMessage");
    const canvas = document.getElementById("wordCloudCanvas");
    if (msg) msg.textContent = "読み込み中...";
    if (canvas) {
      const ctx = canvas.getContext("2d");
      if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
  }

  function setDocumentDailyLoading() {
    const msg    = document.getElementById("documentDailyMessage");
    const canvas = document.getElementById("documentDailyChart");
    if (msg) msg.textContent = "読み込み中...";
    if (canvas) {
      const ctx = canvas.getContext("2d");
      if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
  }

  function reloadAll(urls, startInput, endInput) {
    const start = startInput?.value;
    const end   = endInput?.value;

    if (!start || !end) {
      alert("開始日・終了日を入力してください。");
      return;
    }

    // 日付チェック（開始 > 終了 の場合は弾く）
    if (start > end) {
      alert("集計開始日は集計終了日以前の日付を指定してください。");
      return;
    }

    const params = { start_date: start, end_date: end };

    // 1) まず全ウィジェットにローディング表示
    showLoadingAll();

    // 2) API 呼び出しを「順番に」実行
    const tasks = [
      () => loadTotalUsers(urls.summary, params),
      () => loadLoyalty(urls.loyalty, params),
      () => loadCategories(urls.categories, params),
      () => loadPrefecturePie(urls.prefectures, params),
      () => loadAIConcierges(urls.aiconcierges, params),
      () => loadKeywordCloud(urls.keywords, params),
      () => loadDocumentDaily(urls.documentsDaily, params)
    ];

    // Promise チェーンで順番に実行
    let chain = Promise.resolve();
    tasks.forEach((fn) => {
      chain = chain.then(() => fn());
    });

    // 全部終わったあとに何かしたければここで
    chain.catch((e) => {
      // 個々の loadXXX の catch でUIは処理しているので、ここはログだけでOK
      console.error("[reports_dashboard] reloadAll sequence error:", e);
    });
  }

  function buildUrl(base, params) {
    const url = new URL(base, window.location.origin);
    Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v));
    return url.toString();
  }

  function apiFetch(url, params) {
    const fullUrl = buildUrl(url, params);
    return fetch(fullUrl, {
      headers: { "Accept": "application/json" },
      credentials: "same-origin"
    }).then((res) => {
      if (!res.ok) throw new Error("HTTP " + res.status);
      return res.json();
    });
  }

  // --- 各ウィジェット ---

  function loadTotalUsers(url, params) {
    const el = document.querySelector("[data-widget='total-users']");
    if (!el || !url) return Promise.resolve(); // 何もしないで即 resolve

    return apiFetch(url, params)
      .then((json) => {
        const v = json.total_users || 0;
        el.textContent = v.toLocaleString();
      })
      .catch(() => {
        el.innerHTML = '<span class="report-dashboard-page__error">取得に失敗しました</span>';
      });
  }

  function loadLoyalty(url, params) {
    const tbody = document.querySelector("[data-widget='loyalty-body']");
    if (!tbody || !url) return Promise.resolve();

    return apiFetch(url, params)
      .then((json) => {
        const items = json.items || [];
        if (!items.length) {
          tbody.innerHTML = '<tr><td colspan="2" class="report-dashboard-page__loading">データがありません</td></tr>';
          return;
        }
        tbody.innerHTML = "";
        items.forEach((row) => {
          const tr = document.createElement("tr");
          tr.innerHTML =
            `<td>${escapeHtml(row.label)}</td>` +
            `<td>${Number(row.count || 0).toLocaleString()}</td>`;
          tbody.appendChild(tr);
        });
      })
      .catch(() => {
        tbody.innerHTML = '<tr><td colspan="2" class="report-dashboard-page__error">取得に失敗しました</td></tr>';
      });
  }

  function loadCategories(url, params) {
    const tbody = document.querySelector("[data-widget='category-body']");
    if (!tbody || !url) return Promise.resolve();

    return apiFetch(url, params)
      .then((json) => {
        const items = json.items || [];
        if (!items.length) {
          tbody.innerHTML = '<tr><td colspan="2" class="report-dashboard-page__loading">データがありません</td></tr>';
          return;
        }
        tbody.innerHTML = "";
        items.forEach((row) => {
          const tr = document.createElement("tr");
          tr.innerHTML =
            `<td>${escapeHtml(row.label)}</td>` +
            `<td>${Number(row.count || 0).toLocaleString()}</td>`;
          tbody.appendChild(tr);
        });
      })
      .catch(() => {
        tbody.innerHTML = '<tr><td colspan="2" class="report-dashboard-page__error">取得に失敗しました</td></tr>';
      });
  }

  function loadAIConcierges(url, params) {
    const tbody = document.querySelector("[data-widget='ai-concierge-body']");
    if (!tbody || !url) return Promise.resolve();

    return apiFetch(url, params)
      .then((json) => {
        const items = json.items || [];
        if (!items.length) {
          tbody.innerHTML = '<tr><td colspan="2" class="report-dashboard-page__loading">データがありません</td></tr>';
          return;
        }
        tbody.innerHTML = "";
        items.forEach((row) => {
          const tr = document.createElement("tr");
          tr.innerHTML =
            `<td>${escapeHtml(row.label)}</td>` +
            `<td>${Number(row.count || 0).toLocaleString()}</td>`;
          tbody.appendChild(tr);
        });
      })
      .catch(() => {
        tbody.innerHTML = '<tr><td colspan="2" class="report-dashboard-page__error">取得に失敗しました</td></tr>';
      });
  }

  // 既存の loadPrefecturePie を置き換え
  function loadPrefecturePie(url, params) {
    const canvas = document.getElementById("prefecturePieChart");
    const msg    = document.getElementById("prefecturePieChartMessage");
    const tbody  = document.querySelector("[data-widget='prefecture-body']");
    if (!canvas || !url) return Promise.resolve();

    return apiFetch(url, params)
      .then((json) => {
        const items = json.items || [];

        if (!items.length) {
          if (msg) msg.innerHTML = '<div class="report-dashboard-page__loading">データがありません</div>';
          if (tbody) tbody.innerHTML = '<tr><td colspan="3" class="report-dashboard-page__loading">データがありません</td></tr>';
          if (pieChart) { pieChart.destroy(); pieChart = null; }
          return;
        }

        if (tbody) {
          tbody.innerHTML = "";
          const totalAll = items.reduce((s, i) => s + Number(i.count || 0), 0);
          items.forEach((i) => {
            const count = Number(i.count || 0);
            const ratio = totalAll ? (count / totalAll) * 100 : 0;
            const tr = document.createElement("tr");
            tr.innerHTML =
              `<td>${escapeHtml(i.label)}</td>` +
              `<td>${count.toLocaleString()}</td>` +
              `<td>${ratio.toFixed(1)}%</td>`;
            tbody.appendChild(tr);
          });
        }

        const { labels, values } = buildTopNForChart(items, 10, "その他");

        if (window.ChartDataLabels && window.Chart?.register) {
          Chart.register(window.ChartDataLabels);
        }

        if (pieChart) { pieChart.destroy(); }

        const totalForChart = values.reduce((s, v) => s + v, 0);

        pieChart = new Chart(canvas, {
          type: "pie",
          data: { labels, datasets: [{ data: values }] },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: "right",
                labels: { boxWidth: 10, font: { size: 9 } }
              },
              datalabels: {
                formatter: (value) => {
                  if (!totalForChart || !value) return "";
                  const ratio = (value / totalForChart) * 100;
                  return `${value}\n(${ratio.toFixed(1)}%)`;
                },
                font: { size: 9 },
                color: "#ffffff",
                textAlign: "center",
                display: (ctx) => {
                  const v = ctx.dataset.data[ctx.dataIndex];
                  const r = totalForChart ? (v / totalForChart) * 100 : 0;
                  return r >= 2;
                }
              }
            }
          }
        });
        if (msg) msg.textContent = "";
      })
      .catch(() => {
        if (msg)   msg.innerHTML = '<div class="report-dashboard-page__error">グラフデータ取得に失敗しました</div>';
        if (tbody) tbody.innerHTML = '<tr><td colspan="3" class="report-dashboard-page__error">取得に失敗しました</td></tr>';
        if (pieChart) { pieChart.destroy(); pieChart = null; }
      });
  }

  // チャート用に上位N＋その他へ集約するヘルパー
  function buildTopNForChart(items, topN = 10, othersLabel = "その他") {
    // countの降順でソート
    const sorted = [...items].sort((a, b) => (Number(b.count || 0) - Number(a.count || 0)));

    const top = sorted.slice(0, topN);
    const rest = sorted.slice(topN);

    const labels = top.map(i => i.label);
    const values = top.map(i => Number(i.count || 0));

    const othersTotal = rest.reduce((sum, i) => sum + Number(i.count || 0), 0);
    if (othersTotal > 0) {
      labels.push(othersLabel);
      values.push(othersTotal);
    }
    return { labels, values };
  }

  // ★ 修正：loadKeywordCloud 内で list/max を作ったあとにキャッシュして描画
  function loadKeywordCloud(url, params) {
    const wrap   = document.getElementById("wordCloudWrap");
    const canvas = document.getElementById("wordCloudCanvas");
    const msg    = document.getElementById("wordCloudMessage");
    if (!wrap || !canvas || !url) return Promise.resolve();

    if (msg) msg.textContent = "読み込み中...";

    return apiFetch(url, params)
      .then((json) => {
        const raw = Array.isArray(json.items) ? json.items : [];
        if (!raw.length) {
          if (msg) msg.textContent = "データがありません";
          const ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          return;
        }
        if (typeof window.WordCloud !== "function" || !window.WordCloud.isSupported) {
          if (msg) msg.innerHTML = '<span class="report-dashboard-page__error">ライブラリ未読込 or 非対応</span>';
          return;
        }

        const items = raw
          .map(i => ({ label: String(i.label ?? ""), count: Number(i.count ?? 0) }))
          .filter(i => i.label.length > 0 && Number.isFinite(i.count) && i.count > 0)
          .sort((a,b) => b.count - a.count)
          .slice(0, 200);

        if (!items.length) {
          if (msg) msg.textContent = "有効なデータがありません";
          const ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          return;
        }

        const list = items.map(i => [i.label, i.count]);
        const max  = items[0].count;

        _keywordCloudCache = { list, max };
        drawWordCloud(canvas, list, max);
        if (msg) msg.textContent = "";

        if (!_wordCloudRO) {
          _wordCloudRO = new ResizeObserver(() => {
            if (_keywordCloudCache.list) {
              drawWordCloud(canvas, _keywordCloudCache.list, _keywordCloudCache.max);
            }
          });
          _wordCloudRO.observe(wrap);
        }
      })
      .catch((e) => {
        console.error("[wordcloud] API取得に失敗:", e);
        if (msg) msg.innerHTML = '<span class="report-dashboard-page__error">取得に失敗しました</span>';
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      });
  }

  // 置き換え：親要素のサイズでキャンバスを1:1に
  function resizeCanvasToParent(canvas) {
    const parent = canvas.parentElement;
    const rect = parent.getBoundingClientRect();

    // 充分なサイズを確保（高さはラッパーCSSでも固定してOK）
    const width  = Math.max(320, Math.floor(rect.width));
    const height = Math.max(240, Math.floor(rect.height || 420));

    // 内部サイズとCSSサイズを一致させる
    canvas.width  = width;
    canvas.height = height;
    canvas.style.width  = width + "px";
    canvas.style.height = height + "px";

    // 変換はリセット（devicePixelRatioでの拡大はしない）
    const ctx = canvas.getContext("2d");
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }

  // 追加：描画だけを行う関数（サイズ変更時にも使う）
  function drawWordCloud(canvas, list, max) {
    if (!canvas || !Array.isArray(list) || !list.length) return;
    // 親サイズに合わせる
    resizeCanvasToParent(canvas);

    // キャンバスが大きいほどフォント上限も上げる
    const shortest = Math.min(canvas.width, canvas.height);
    const maxPx = Math.max(48, Math.round(shortest / 10)); // 例: 480pxなら48、1000pxなら100
    const minPx = 10;

    const weightFactor = (size) => {
      if (!max) return minPx;
      return Math.max(minPx, Math.round((size / max) * maxPx));
    };

    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    window.WordCloud(canvas, {
      list,
      // 画面が大きくなったらグリッドを細かくし過ぎないように相対設定
      gridSize: Math.max(6, Math.round(shortest / 120)),
      weightFactor,
      rotateRatio: 0.1,
      rotationSteps: 2,
      backgroundColor: "#ffffff",
      color: (word, weight) => {
        const t = max ? (weight / max) : 0.5;
        const h = 200 - Math.round(t * 60);
        const s = 70;
        const l = 40 + Math.round(20 * t);
        return `hsl(${h} ${s}% ${l}%)`;
      },
      drawOutOfBound: false,
      shrinkToFit: true,
      clearCanvas: true
    });
  }

  function loadDocumentDaily(url, params) {
    const canvas = document.getElementById("documentDailyChart");
    const msg    = document.getElementById("documentDailyMessage");
    if (!canvas || !url) return;

    if (msg) msg.textContent = "読み込み中...";

    apiFetch(url, params)
      .then((json) => {
        const labels = json.labels || [];
        const data   = json.data   || [];

        if (!labels.length) {
          if (msg) msg.textContent = "データがありません";
          if (documentDailyChart) { documentDailyChart.destroy(); documentDailyChart = null; }
          return;
        }
        if (msg) msg.textContent = "";

        if (documentDailyChart) documentDailyChart.destroy();

        documentDailyChart = new Chart(canvas, {
          type: "line",
          data: {
            labels,
            datasets: [{
              label: "アクセス数",
              data,
              fill: false,
              tension: 0.25,        // 線を少し滑らかに
              pointRadius: 2,
              pointHoverRadius: 4,
              borderWidth: 2
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              x: {
                ticks: { autoSkip: true, maxTicksLimit: 14 }
              },
              y: {
                beginAtZero: true,
                suggestedMax: Math.max(...data, 5) // 余白を少し
              }
            },
            plugins: {
              legend: { display: false },
              tooltip: {
                mode: "index",
                intersect: false
              }
            },
            interaction: {
              mode: "index",
              intersect: false
            }
          }
        });
      })
      .catch(() => {
        if (msg) msg.innerHTML = '<span class="report-dashboard-page__error">取得に失敗しました</span>';
        if (documentDailyChart) { documentDailyChart.destroy(); documentDailyChart = null; }
      });
  }

  // --- util ---
  function formatDate(d) {
    const y = d.getFullYear();
    const m = ("0" + (d.getMonth() + 1)).slice(-2);
    const day = ("0" + d.getDate()).slice(-2);
    return `${y}-${m}-${day}`;
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }
})();
